<template>
  <div id="left-col" class="pure-u-1-5 aux-col" v-bind:class="{ viewingAux: isAuxView, viewingRated: isRatedView, forceShow: forceLHShow }">
  	<div id="grapevines-list-wrap">
      <div class="grapevines-heading-wrap">
        <h5 class="aux-heading">Your grapevines</h5>
        <select id="grapevines-sort" v-on:change="grapevinesSort()">
          <option value="az">A-Z</option>
          <!-- <option value="date">Date</option> -->
          <option value="count">Count</option>
        </select>
			</div>
      <div class="input-field add-grapevine-form">
        <input name="grapevine_name" placeholder="New grapevine" id="grapevine_name" type="text" class="validate" autocomplete="off" maxlength="35" ref="grapevineName" v-model="grapevineName" v-on:keyup.enter="createGrapevine">
        <div v-on:click="createGrapevine" class="add-grapevine-trigger"><i class="fal fa-plus-circle"></i><i class="fas fa-circle-notch fa-spin"></i></div>
        <p class="notice">{{addGrapevineNotice}}</p>
      </div>

      <router-link class="pure-button view-grapevines-button" :to="yourGrapevinesLink" v-if="isLoggedIn">View grapevines</router-link>

      <ul id="my-grapevines-list" class="grapevines-list">
      <li class="top-rated" v-if="isLoggedIn">
        <router-link class="list-link" v-on:click.native="showTopRated()" to="/top-rated"><img class="grape-img" :src="ratedVine.grapeImage" v-if="ratedVine.grapeImage" /><span class="grapevine-name">Your top-rated grapes</span><span class="grapes-count"><i class="fal fa-circle"></i> {{ratedVine.count}}</span></router-link>
        <div class="hover-line"></div>
      </li>
			<li v-for="grapevine in grapevines" :data-id="grapevine.id" :data-name="grapevine.name" :data-private="grapevine.isPrivate" :data-read-only="grapevine.isReadOnly" :data-created="grapevine.created">
        <router-link class="list-link" v-on:click.native="clickGrapevine(grapevine.id, grapevine.name, grapevine.isReadOnly)" v-bind:to="{ name: 'grapevine', params: { id: grapevine.id, name: encodeURIComponent(grapevine.name) } }"><img class="grape-img" :src="grapevine.grapeImage" v-if="grapevine.grapeImage" /><span class="grapevine-name">{{ grapevine.name }}</span><span class="grapes-count"><i class="fal fa-circle"></i> {{grapevine.count}}</span><i class="fal fa-circle-notch" v-if="grapevine.isReadOnly"></i><i class="fal fa-lock" v-if="grapevine.isPrivate"></i></router-link>
        <div class="hover-line"></div>
			</li>
			</ul>
		</div><!-- #grapevines-list-wrap -->
		<div id="grapes-list-wrap">
      <div class="grapevine-heading-wrap">
        <h5 class="aux-heading is-editing-hide">{{decodeURIComponent(this.grapesHeading)}}</h5>
        <input class="is-editing-show" type="text" placeholder="Enter new title" v-model="grapevineNewName" v-on:keyup.enter="confirmTitleEdit()" />
        <div class="grapevine-context">
          <a class="context-edit-grapevine" href="#" :data-grapevine-id="currentGrapevineID"><i class="fal fa-bars"></i></a>
        </div>
        <div class="button-cancel is-editing-show" v-on:click.stop.prevent="cancelTitleEdit()">
          <i class="fal fa-times"></i>
        </div>
        <div class="button-confirm is-editing-show" v-on:click.stop.prevent="confirmTitleEdit()">
          <i class="fal fa-check"></i>
        </div>
        <div class="button-back is-editing-hide" v-on:click.stop.prevent="backToGrapevines()">
          <i class="fal fa-long-arrow-left"></i>
        </div>
        <div class="button-edit-title is-editing-hide" style="display: none!important;" v-if="currentGrapevineOwner" v-on:click.stop.prevent="editGrapevineTitle()">
          <i class="fal fa-pencil"></i>
        </div>
      </div>
      <div class="grapevine-share-wrap sidebar-share-wrap">
        <button class="pure-button grapevine-add-button add-grapevine" v-on:click.stop.prevent="addGrapevine()">Add<i class="fal fa-plus"></i></button>
        <button class="pure-button grapevine-share-button accent" v-on:click.stop.prevent="shareGrapevineShow()">Share</button>
        <button class="pure-button remove-grapevine" v-on:click.stop.prevent="removeGrapevine()">Remove<i class="fal fa-minus"></i></button>
        <button class="pure-button grapevine-delete-button delete-grapevine hidden" v-on:click.stop.prevent="deleteGrapevine()">Delete<i class="fal fa-times"></i></button>
        <div class="private-public-switch" v-if="currentGrapevineOwner">
          <label class="switch">
            <input class="switch-input" type="checkbox" v-model="grapevinePrivacy" true-value="private" false-value="public" v-on:change="changeGrapevinePrivacy()" />
            <span class="switch-label" data-on="Private" data-off="Public"></span> 
            <span class="switch-handle"></span> 
          </label>
        </div>
        <!-- <button class="pure-button grapevine-public-button" v-on:click.stop.prevent="makeGrapevinePublic()" v-if="currentGrapevinePrivate && currentGrapevineOwner">Public</button>
        <button class="pure-button grapevine-private-button" v-on:click.stop.prevent="makeGrapevinePrivate()" v-if="!currentGrapevinePrivate && currentGrapevineOwner">Private</button> -->
        <button class="pure-button grapevine-groupvine-button" v-on:click.stop.prevent="makeGroupvine()" v-if="!isGroupvine && currentGrapevineOwner">Groupvine</button>

        <ul class="share-links" v-if="currentGrapevineID">
          <li class="twitter"><a :href="'https://twitter.com/share?text=Read ' + currentGrapevineName + ' on Grapevine&url=' + grapevinePath + currentGrapevineID + '/' + currentGrapevineName" target="_blank" class="share-link share-twitter" v-on:click="shareGrapevine('twitter')"><i class="fab fa-twitter"></i></a></li>
          <li class="facebook"><a :href="'https://www.facebook.com/sharer/sharer.php?u=' + grapevinePath + currentGrapevineID + '/' + currentGrapevineName" target="_blank" class="share-link share-facebook" v-on:click="shareGrapevine('facebook')"><i class="fab fa-facebook"></i></a></li>
          <li class="direct"><a :href="grapevinePath + currentGrapevineID + '/' + currentGrapevineName" class="share-link share-direct-link" v-on:click="shareGrapevine('link')"><i class="fal fa-link"></i></a></li>
        </ul>
      </div>
      <div class="groupvine-participants" v-if="isGroupvine">
        <h5>This groupvine <a href="#" v-on:click.stop.prevent="editGroupvine" v-if="currentGrapevineOwner">Edit</a></h5>
        <ul class="participants-list">
          <li v-if="currentGrapevineOwner">you*</li><li v-else><router-link v-on:click.stop.native="grapeUserTrigger(currentGrapevineUserID, currentGrapevineUsername)" v-bind:to="{ name: 'user', params: { username: currentGrapevineUsername }}">@{{currentGrapevineUsername}}*</router-link></li><li v-for="participant in participants" class="participant" :data-id="participant.id">
            <router-link v-on:click.stop.native="grapeUserTrigger(participant.id, participant.username)" v-bind:to="{ name: 'user', params: { username: participant.username }}">@{{participant.username}}</router-link>
          </li>
        </ul>
        <button class="pure-button groupvine-chat-button" v-on:click.stop.prevent="groupvineChat()">Groupvine Chat</button>
      </div>
      <div v-if="grapes.length == 0 && isGroupvine" class="start-grapevine" v-on:click.stop.prevent="startGrapevine()">
        Start this groupvine by adding a grape
      </div>
      <div v-if="grapes.length == 0 && !isGroupvine" class="start-grapevine" v-on:click.stop.prevent="startGrapevine()">
        Start this grapevine by adding a grape
      </div>
			<ul id="grapes-list" class="grapes-list">
			<li v-for="grape in grapes" class="grape-list-grape" :data-id="grape.id">
			  <!--<router-link class="button is-primary" v-bind:to="{ name: 'view-grape', params: { grapeID: grape.id }}">{{ grape.grapeTitle }}</router-link><div class="remove-grape" v-on:click.stop.prevent="removeGrapeFromGrapevine(grape.id)"><i class="fal fa-times"></i></div>-->
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-img-link"><img class="grape-img" :src="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage" /></a>
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-title">{{ grape.grapeTitle }}</a>
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-author">{{ grape.sourceAuthor }}</a>
        <div class="remove-grape" v-on:click.stop.prevent="removeGrapeFromGrapevine(grape.id)" v-if="currentGrapevineOwner"><i class="fal fa-times"></i></div>
			</li>
			</ul>
		</div><!-- #grapes-list-wrap -->
    <div id="aux-grapes-wrap">
      <div class="grapevine-heading-wrap">
        <h5 class="aux-heading">{{this.auxTitle}}'s grapes</h5>
        <div class="button-back is-editing-hide" v-on:click.stop.prevent="backToGrapevines()">
          <i class="fal fa-long-arrow-left"></i>
        </div>
      </div>
      <div class="author-share-wrap sidebar-share-wrap">
        <button class="pure-button grapevine-share-button accent" v-on:click.stop.prevent="shareAuxShow()">Share</button>
        <ul class="share-links" v-if="isAuxView">
          <li class="twitter"><a :href="'https://twitter.com/share?text=Read ' + auxTitle + '\'s grapes on Grapevine&url=' + auxSharePath" target="_blank" class="share-link share-twitter"><i class="fab fa-twitter"></i></a></li>
          <li class="facebook"><a :href="'https://www.facebook.com/sharer/sharer.php?u=' + auxSharePath" target="_blank" class="share-link share-facebook"><i class="fab fa-facebook"></i></a></li>
          <li class="direct"><a :href="auxSharePath" class="share-link share-direct-link" v-on:click.stop.prevent="shareAux('link', auxSharePath)"><svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="Layer 2" id="Layer_2"><g data-name="Layer 1" id="Layer_1-2"><path d="M14.34372,9.582c2.42249-2.29746,4.44536-2.16138,4.44536-2.16138a4.63859,4.63859,0,0,1,4.63859,4.63859,4.76853,4.76853,0,0,1-4.63859,4.63859c-1.85094.136-3.41384-1.0205-4.6329-2.22393-1.43147-1.41312-3.66825-4.40545-5.42326-5.7671A5.59084,5.59084,0,0,0,5.22175,7.42064a4.63859,4.63859,0,1,0,0,9.27719s1.93263.22982,4.38638-2.052" fill="none" stroke="#36a731" stroke-linecap="round" stroke-linejoin="round"/></g><g data-name="Layer 2" id="Layer_2-2"><rect fill="none" height="24" width="24"/></g></g></svg></a></li>
        </ul>
      </div>
      <ul id="author-grapes-list" class="grapes-list">
        <li v-for="grape in auxGrapes" class="grape-list-grape" :data-id="grape.id">
          <!--<router-link class="button is-primary" v-bind:to="{ name: 'view-grape', params: { grapeID: grape.id }}">{{ grape.grapeTitle }}</router-link><div class="remove-grape" v-on:click.stop.prevent="removeGrapeFromGrapevine(grape.id)"><i class="fal fa-times"></i></div>-->
          <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-img-link"><img class="grape-img" :src="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage" /></a>
          <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-title">{{ grape.grapeTitle }}</a>
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-author" v-if="isPress">{{ grape.grapePublication }}</a>
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-author" v-else>{{ grape.grapeSource }}</a>
        </li>
      </ul>
    </div><!-- #aux-grapes-wrap -->
    <div id="rated-grapes-wrap">
      <div class="grapevine-heading-wrap">
        <h5 class="aux-heading">Your top-rated grapes</h5>
        <div class="button-back is-editing-hide" v-on:click.stop.prevent="backToGrapevines()">
          <i class="fal fa-long-arrow-left"></i>
        </div>
      </div>
      <ul id="rated-grapes-list" class="grapes-list">
        <li v-for="grape in ratedGrapes" class="grape-list-grape" :data-id="grape.id">
          <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-img-link"><img class="grape-img" :src="grape.sourceImage.replace('http://', 'https://')" v-if="grape.sourceImage" /></a>
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-title">{{ grape.grapeTitle }}</a>
        <a href="#" v-on:click.stop.prevent="scrollToGrape(grape.id)" class="grape-author">{{ grape.sourceAuthor }}</a>
        </li>
      </ul>
    </div><!-- #rated-grapes-wrap -->
    <div class="user-search" id="user-search-dialog">
      <div class="dialog-close" v-on:click="closeEditGroupvine">&times;</div>
      <h4 class="dialog-header">Add readers to this groupvine</h4>
      <div class="search-dialog-inner">
        <input id="participant-search-users" type="text" v-model="userSearchQuery" v-on:keyup.enter="searchUsers" placeholder="Search" />
        <div v-on:click="searchUsers" class="search-trigger"><i class="fal fa-search"></i></div>
      </div>
      <ul id="participant-users-list">
        <li v-for="user in userSearchResults">
          <a class="button is-primary" href="#" v-on:click.stop.prevent="addParticipant(user.key, user.username)">{{user.username}}</a>
        </li>
      </ul>
      <h5>Current members</h5>
      <ul class="participants-list current-participants-list">
        <li v-for="participant in participants" class="participant" :data-id="participant.id">
          <a href="#" v-on:click.stop.prevent="removeParticipant(participant.id, participant.username)">@{{participant.username}}</a>
        </li>
      </ul>
    </div>
	</div>
</template>

<script>
  /* global $, mixpanel */
  import db from './firebaseInit'
  import firebase from 'firebase'
  import Router from '../router'
  import Request from 'superagent'
  import 'vuejs-noty/dist/vuejs-noty.css'
  const crypto = require('crypto');

  export default {
    name: 'LeftSidebar',
    data () {
      return {
        grapesHeading: '',
        currentUserID: null,
        isLoggedIn: false,
        grapevines: [],
        grapevineName: null,
        titleEditing: false,
        currentGrapevineName: '',
        currentGrapevineID: null,
        currentGrapevineUserID: null,
        currentGrapevineUsername: null,
        currentGrapevineOwner: false,
        currentGrapevinePrivate: false,
        grapevinePrivacy: 'public',
        addGrapevineNotice: '',
        grapevineNewName: '',
        grapes: [],
        firstLoad: true,
        author: '',
        auxGrapes: [],
        auxSharePath: '',
        publication: '',
        auxTitle: '',
        isAuxView: false,
        isRatedView: false,
        ratedVine: {
          grapeImage: null,
          count: 0
        },
        scrollGrapeID: null,
        ratedGrapeIDs: [],
        ratedGrapes: [],
        isAddingGrapevine: false,
        forceLHShow: false,
        isGroupvine: false,
        participants: [],
        userSearchQuery: null,
        userSearchResults: [],
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        grapeRatingsDatabase: this.$globals.grapeRatingsDatabase,
        isPress: this.$globals.isPress,
        basePath: '/',
        grapevinePath: this.$globals.grapevinePath,
        authorPath: this.$globals.authorPath,
        bookPath: this.$globals.bookPath,
        publicationPath: this.$globals.publicationPath,
        yourGrapevinesLink: '/your-grapevines'
      }
    },
    created () {
      var vm = this
      if (this.isPress) {
        // this.basePath = '/print'
        // this.grapevinePath = '/#/print/grapevine/'
        // this.yourGrapevinesLink = '/print/your-grapevines'
      }
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.isLoggedIn = true
          vm.ratedGrapeIDs = []
          vm.ratedGrapes = []
          vm.getGrapevines()
          vm.getTopRated()
          vm.getRatedGrapes()
          vm.checkUserIsFollowing()
          vm.checkCurrentGrapevineOwner(vm.currentGrapevineID)
          vm.addGrapevineNotice = ''
          vm.grapevineName = ''
        } else {
          vm.currentUserID = null
          vm.isLoggedIn = false
          vm.grapevines = []
          vm.ratedGrapeIDs = []
          vm.ratedGrapes = []
          $('#left-col').removeClass('viewing-grapevine')
          vm.grapes = []
        }
      })
      this.$eventHub.$on('new-grapevine-created', function (id) {
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(id)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            let data = doc.data()
            var grapevineData = {
              name: data.name,
              id: doc.id,
              isReadOnly: false,
              isPrivate: data.privacy === 'private',
              created: data.createdTimestamp
            }
            if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.grapevines.push(grapevineData)
              vm.grapevinesSort()
              vm.setGrapevinesGlobal()
            }
          }
        })
      })
      this.$eventHub.$on('grape-add-to-grapevine', function (id) {
        console.log(id + ' --- ' + vm.currentGrapevineID)
        if (id === vm.currentGrapevineID) {
          vm.clickGrapevine(vm.currentGrapevineID, '')
        }
        vm.refreshGrapevine(id)
      })

      this.$eventHub.$on('external-trigger-grapevine', function () {
        vm.clickGrapevine(vm.$route.params.id, vm.$route.params.name)
      })

      this.$eventHub.$on('viewing-author-page', function (id) {
        console.log(id)
        vm.author = id
        vm.auxTitle = id
        vm.auxSharePath = vm.authorPath + encodeURI(id)
        console.log('auxSharePath updated: ' + vm.auxSharePath)
        vm.setupViewAuthor(id)
      })

      this.$eventHub.$on('viewing-book-page', function (title) {
        console.log(title)
        vm.book = title
        vm.auxTitle = title
        vm.auxSharePath = vm.bookPath + encodeURI(title)
        console.log('auxSharePath updated: ' + vm.auxSharePath)
        vm.setupViewBook(title)
      })

      this.$eventHub.$on('viewing-publication-page', function (title) {
        console.log(title)
        vm.publication = title
        vm.auxTitle = title
        vm.auxSharePath = vm.publicationPath + encodeURI(title)
        console.log('auxSharePath updated: ' + vm.auxSharePath)
        vm.setupViewPublication(title)
      })

      this.$eventHub.$on('user-role-set', function () {
        if (vm.currentGrapevineID) {
          vm.checkCurrentGrapevineOwner(vm.currentGrapevineID)
        }
      })

      this.$eventHub.$on('navigate-home', function () {
        console.log('navigate-home')
        if (vm.currentGrapevineID || vm.isAuxView || vm.isRatedView) {
          vm.backToGrapevines()
        }
      })

      this.$eventHub.$on('mobile-grapevines-show-trigger', function () {
        if (vm.forceLHShow) {
          vm.forceLHShow = false
          $('html').removeClass('fixed')
        } else {
          vm.forceLHShow = true
          $('html').addClass('fixed')
        }
        console.log('mobile-grapevines-show-trigger')
      })

      this.$eventHub.$on('mobile-grapevines-hide-trigger', function () {
        vm.forceLHShow = false
        $('html').removeClass('fixed')
        console.log('mobile-grapevines-hide-trigger')
      })

      this.$eventHub.$on('grape-rated-trigger', function () {
        vm.getTopRated()
        vm.getRatedGrapes()
        console.log('grape-rated-trigger')
      })

      // vm.initDialog()

      vm.initSidebar()
    },
    beforeDestroy () {
      this.$eventHub.$off('new-grapevine-created')
      this.$eventHub.$off('grape-add-to-grapevine')
      this.$eventHub.$off('external-trigger-grapevine')
      this.$eventHub.$off('viewing-author-page')
      this.$eventHub.$off('viewing-book-page')
      this.$eventHub.$off('viewing-publication-page')
      this.$eventHub.$off('user-role-set')
      this.$eventHub.$off('navigate-home')
      this.$eventHub.$off('mobile-grapevines-show-trigger')
      this.$eventHub.$off('mobile-grapevines-hide-trigger')
      this.$eventHub.$off('grape-rated-trigger')
    },
    watch: {
      '$route': 'initSidebar'
    },
    methods: {
      initSidebar: function () {
        var vm = this
        if (this.$route.name === 'grapevine' && vm.firstLoad && this.$route.params.id && this.$route.params.name) {
          vm.clickGrapevine(this.$route.params.id, this.$route.params.name)
        } else if (this.$route.name !== 'user' && this.$route.name !== 'search') {
          $('#left-col').removeClass('viewing-grapevine')
          vm.grapes = []
        }
      },
      grapeUserTrigger (userID, username) {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        this.$eventHub.$emit('grape-user-trigger', userID, username)
      },
      getGrapevines: function () {
        console.log('getGrapevines')
        var vm = this
        vm.grapevines = []

        // Created Public
        db.collection(vm.grapevinesDatabase).where('userID', '==', vm.currentUserID).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log('fetch: ' + doc.id, ' => ', doc.data())
            let data = doc.data()
            var grapevineData = {
              name: data.name,
              id: doc.id,
              isReadOnly: false,
              grapes: data.grapes,
              groupvine: data.groupvine,
              grapeImage: null,
              count: data.grapes.length,
              isPrivate: data.privacy === 'private',
              created: data.createdTimestamp
            }

            if (data.participants) {
              let participants = data.participants
              for (var participant in participants) {
                var obj = participants[participant]
                grapevineData.count += obj.grapes.length
              }
            }
            
            if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.getGrapevineImage(grapevineData)
            }
          })
        })

        // Groupvines
        db.collection(vm.grapevinesDatabase).where('participantIDs.' + vm.currentUserID, '==', true).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log('fetch: ' + doc.id, ' => ', doc.data())
            let data = doc.data()
            var grapevineData = {
              name: data.name,
              id: doc.id,
              isReadOnly: false,
              grapes: data.grapes,
              groupvine: data.groupvine,
              grapeImage: null,
              count: data.grapes.length,
              isPrivate: data.privacy === 'private',
              created: data.createdTimestamp
            }

            if (data.participants) {
              let participants = data.participants
              for (var participant in participants) {
                var obj = participants[participant]
                grapevineData.count += obj.grapes.length
              }
            }

            if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.getGrapevineImage(grapevineData)
            }
          })
        })

        // Followed
        var grapevinesFollowRef = firebase.database().ref('users/' + vm.currentUserID)
        grapevinesFollowRef.on('child_added', function (data) {
          var grapevineFollowData = data.val()
          console.log(grapevineFollowData)
          if (grapevineFollowData) {
            for (var i = 0; i < grapevineFollowData.length; i++) {
              let thisGrapevineID = grapevineFollowData[i]
              var grapevineRef = db.collection(vm.grapevinesDatabase).doc(thisGrapevineID)
              grapevineRef.get().then(function (doc) {
                if (doc.exists) {
                  let data = doc.data()
                  var grapevineData = {
                    name: data.name,
                    id: thisGrapevineID,
                    isReadOnly: true,
                    isPrivate: false,
                    grapes: data.grapes,
                    grapeImage: null,
                    count: data.grapes.length > 0 ? data.grapes.length : 0,
                    created: data.createdTimestamp
                  }
                  if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
                    vm.getGrapevineImage(grapevineData)
                  }
                }
              })
            }
          }
        })
      },
      grapevinesSort: function () {
        let vm = this
        let $sort = $('#grapevines-sort').val()
        if ($sort === 'az') {
          vm.grapevines.sort(function (a, b) {
            var textA = a.name.toUpperCase()
            var textB = b.name.toUpperCase()
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
          })
        } else if ($sort === 'oldest') {
          vm.grapevines.sort(function (a, b) {
            var dateA = a.created ? parseFloat(a.created) : 0
            var dateB = b.created ? parseFloat(b.created) : 0
            return dateA - dateB
          })
        } else if ($sort === 'count') {
          vm.grapevines.sort(function (a, b) {
            var countA = a.count ? parseInt(a.count) : 0
            var countB = b.count ? parseInt(b.count) : 0
            return countB - countA
          })
        } else {
          vm.grapevines.sort(function (a, b) {
            var reverseTextA = a.created ? parseFloat(a.created) : 0
            var reverseTextB = b.created ? parseFloat(b.created) : 0
            return reverseTextB - reverseTextA
          })
        }
      },
      getGrapevineImage: function (grapevine) {
        let vm = this
        if (grapevine.grapes && grapevine.grapes.length > 0 && !grapevine.image) {
          db.collection(vm.grapesDatabase).where('id', '==', grapevine.grapes[0]).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapevine.grapeImage = grapeData.sourceImage
              if (vm.isPress) {
                if (!grapeData.sourceImage) {
                  grapevine.grapeImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
                }
              } else {
                grapevine.grapeImage = grapeData.sourceImage
                grapevine.grapeImage = grapevine.grapeImage.replace('http://', 'https://')                
              }
              vm.grapevines.push(grapevine)
              vm.grapevinesSort()
              vm.setGrapevinesGlobal()
            })
          })
        } else {
          vm.grapevines.push(grapevine)
          vm.grapevinesSort()
          vm.setGrapevinesGlobal()
        }
      },
      refreshGrapevine: function (id) {
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(id)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            let data = doc.data()
            var grapevineData = {
              name: data.name,
              id: id,
              isReadOnly: false,
              isPrivate: false,
              grapes: data.grapes,
              grapeImage: null,
              count: data.grapes.length,
              created: data.createdTimestamp
            }
            vm.grapevines.splice(vm.grapevines.findIndex(function (i) {
              return i.id === id;
            }), 1)
            if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.getGrapevineImage(grapevineData)
            }
          }
        })
      },
      createGrapevine: function () {
        let vm = this
        if (!this.currentUserID) {
          vm.addGrapevineNotice = 'You must be signed in to create a grapevine'
          return
        }
        if (this.grapevineName && this.grapevineName.length < 3) {
          vm.addGrapevineNotice = 'Grapevine name is too short'
          return
        }
        if (!vm.isAddingGrapevine && this.grapevineName.length >= 3) {

          vm.isAddingGrapevine = true
          let grapevineName = this.grapevineName
          let userID = this.currentUserID
          $('#grapevine_name').prop('disabled', true)
          $('.add-grapevine-trigger').addClass('is-adding')
          let grapevineData = {
            'name': grapevineName,
            'privacy': 'public',
            'userID': userID,
            'grapes': [],
            'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
          }
          mixpanel.track(
            'Create grapevine',
            {
              'grapevineName': grapevineName
            }
          )
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          db.collection(vm.grapevinesDatabase).add(grapevineData).then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.grapevineName = ''
            docRef.get().then(function (doc) {
              if (doc.exists) {
                let data = doc.data()
                var grapevineData = {
                  name: data.name,
                  id: doc.id,
                  isReadOnly: false,
                  isPrivate: data.privacy === 'private',
                  created: data.createdTimestamp,
                  count: 0,
                  random: random
                }
                if (!vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
                  vm.grapevines.push(grapevineData)
                  vm.grapevinesSort()
                  vm.setGrapevinesGlobal()
                }
                vm.$noty.success('Grapevine created')
                setTimeout(function () {
                  vm.isAddingGrapevine = false
                  $('#grapevine_name').prop('disabled', false)
                  $('.add-grapevine-trigger').removeClass('is-adding')
                }, 500)
              }
            })
          })
        }
      },
      generateUUID () {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
      },
      clickGrapevine (grapevineID, grapevineName) {
        if (!grapevineID) {
          return
        }
        if (grapevineName) {
          $('html, body').animate({ scrollTop: 0 }, 'slow') // scroll top only when actual click, not from is vined
        }
        let vm = this
        mixpanel.track(
          'Click grapevine',
          {
            'grapevineID': grapevineID,
            'grapevineName': grapevineName
          }
        )
        vm.grapeIDs = []
        vm.participants = []
        vm.isGroupvine = false
        vm.checkCurrentGrapevineOwner(grapevineID)
        if (grapevineName !== '') {
          vm.currentGrapevineName = grapevineName
          vm.grapesHeading = grapevineName
        }
        vm.currentGrapevineID = grapevineID
        vm.currentGrapevinePrivate = false
        vm.grapevinePrivacy = 'public'
        $('#grapes-list-wrap').attr('data-grapevine-id', grapevineID)
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(grapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            if (doc.data().privacy === 'private') {
              vm.currentGrapevinePrivate = true
              vm.grapevinePrivacy = 'private'
            }
            let grapes = doc.data().grapes
            for (var i = 0; i < grapes.length; i++) {
              vm.grapeIDs.push(grapes[i])
            }
            if (doc.data().groupvine) {
              vm.isGroupvine = true
              let participants = doc.data().participants
              for (var participant in participants) {
                var obj = participants[participant]
                vm.getParticipantData(participant)
                for (var g = 0; g < obj.grapes.length; g++) {
                  console.log('added participant grape')
                  vm.grapeIDs.push(obj.grapes[g])                  
                }
              }
            }
            vm.getGrapes()
            vm.isAuxView = false
          }
        })
        vm.firstLoad = false
        vm.checkUserIsFollowing()
        vm.buildContextMenu()
      },
      getParticipantData: function (participantID) {
        console.log('getParticipantData: ' + participantID)
        let vm = this
        firebase.database().ref('users/' + participantID).once('value', function (snapshot) {
          var exists = (snapshot.val() !== null)
          if (exists) {
            var participantData = {
              id: participantID,
              username: snapshot.val().username
            }
            vm.participants.push(participantData)
          }
        })
      },
      // getParticipantGrapes: function (participantID) {
      //   console.log('getParticipantGrapes')
      //   let vm = this
      //   var userGrapesRef = db.collection('grapevines').doc(vm.currentGrapevineID).collection('participants').doc(participantID);
      //   userGrapesRef.get().then(function (doc) {
      //     if (doc.exists) {
      //       console.log('participant doc exists')
      //       let grapes = doc.data().grapes
      //       for (var i = 0; i < grapes.length; i++) {
      //         vm.grapeIDs.push(grapes[i])
      //       }
      //       vm.getGrapes()
      //     } else {
      //       console.log('participant doc dpes not exist')
      //     }
      //   })
      // },
      getUsernameFromID: function (userID) {
        let vm = this
        firebase.database().ref('users/' + userID).once('value', function (snapshot) {
          var exists = (snapshot.val() !== null)
          if (exists) {
            console.log(snapshot.val().username)
            vm.currentGrapevineUsername = snapshot.val().username
          } else {
            return false
          }
        })
      },
      getGrapes: function () {
        let vm = this
        if (this.grapeIDs.length > 0) {
          var i = 0
          this.grapeIDs.forEach(grapeID => {
            db.collection(vm.grapesDatabase).where('id', '==', grapeID).get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                if (vm.isPress) {
                  if (!grapeData.sourceImage) {
                    grapeData.sourceImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
                  }
                }
                if (!vm.checkGrapePresent(vm.grapes, grapeData.id, true)) {
                  vm.grapes.push(grapeData)
                }
                $('#left-col').stop().animate({ scrollTop: 0 }, '400', function () {
                  $(window).trigger('resize')
                })
                $('#left-col').addClass('viewing-grapevine')
              })
            })
            i++
            if (i == this.grapeIDs.length && vm.scrollGrapeID) {
              setTimeout(function() {
                vm.scrollToGrape(vm.scrollGrapeID)
              }, 2000)
            }
          })
        } else {
          $('#left-col').stop().animate({ scrollTop: 0 }, '400', function () {
            $(window).trigger('resize')
          })
          $('#left-col').addClass('viewing-grapevine')
        }
      },
      checkGrapevinePresent: function (inArr, grapevineID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapevineID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      checkGrapePresent: function (inArr, grapeID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapeID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      checkUserIsFollowing: function () {
        let vm = this
        $('#grapes-list-wrap').removeClass('is-following')
        var grapevinesFollowRef = firebase.database().ref('users/' + vm.currentUserID)
        grapevinesFollowRef.once('value').then(function (snapshot) {
          if (snapshot.val()) {
            let grapevinesFollowed = snapshot.val().grapevinesFollowed
            if ($.isArray(grapevinesFollowed)) {
              if ($.inArray(vm.currentGrapevineID, grapevinesFollowed) > -1) {
                $('#grapes-list-wrap').addClass('is-following')
              }
            }
          }
        })
      },
      buildContextMenu: function () {
        /**********************************************
        ***
        *** Context Menu function
        ***
        **********************************************/
        let $vue = this
        $.contextMenu({
          selector: '.context-edit-grapevine',
          trigger: 'left',
          build: function ($trigger, e) {
            e.preventDefault()
            // var $grapevineID = e.target.dataset.grapevineID
            // this callback is executed every time the menu is to be shown
            // its results are destroyed every time the menu is hidden
            // e is the original contextmenu event, containing e.pageX and e.pageY (amongst other data)
            var $items = {}

            if ($vue.currentGrapevineOwner) {
              $items['rename'] = {
                name: 'Rename',
                callback: function (key, opt) {
                  $vue.editGrapevineTitle()
                }
              }
              // if ($vue.currentGrapevinePrivate) {
              //   $items['makePublic'] = {
              //     name: 'Make public',
              //     callback: function (key, opt) {
              //       $vue.makeGrapevinePublic()
              //     }
              //   }
              // } else {
              //   $items['makePrivate'] = {
              //     name: 'Make private',
              //     callback: function (key, opt) {
              //       $vue.makeGrapevinePrivate()
              //     }
              //   }
              // }
            }
            $items['duplicate'] = {
              name: 'Duplicate',
              callback: function (key, opt) {
                $vue.duplicateGrapevine()
              }
            }
            if ($vue.currentGrapevineOwner) {
              $items['delete'] = {
                name: 'Delete',
                callback: function (key, opt) {
                  $vue.deleteGrapevine()
                }
              }
            }
            console.log($items)
            return {
              items: $items
            }
          }
        })
      },
      makeGroupvine: function () {
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            vm.isGroupvine = true
            grapevineRef.update({
              groupvine: true,
              participantIDs: {},
              participants: {}
            }).then(function () {
              console.log('Groupvine successfully updated!')
            }).catch(function (error) {
              console.error('Error removing document: ', error)
            })
          }
        })
      },
      editGroupvine: function () {
        console.log('editGroupvine')
        let vm = this
        $('#user-search-dialog').addClass('dialog-open')
      },
      closeEditGroupvine: function () {
        $('#user-search-dialog').removeClass('dialog-open')
      },
      startGrapevine: function () {
        Router.push(this.basePath)
      },
      groupvineChat: function () {
        let vm = this
        var chatData = {
          name: vm.currentGrapevineName,
          id: vm.currentGrapevineID,
          members: vm.participants
        }
        this.$eventHub.$emit('message-group', chatData)
      },
      searchUsers: function () {
        let vm = this
        let queryText = this.userSearchQuery
        vm.userSearchResults = []
        var userRef = firebase.database().ref('users')
        userRef.orderByChild('username').startAt(queryText).endAt(queryText + '\uf8ff').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            var item = childSnapshot.val()
            item.key = childSnapshot.key
            vm.userSearchResults.push(item)
          })
        })
      },
      addParticipant: function (userID, username) {
        console.log(userID)
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            var participantIDs = doc.data().participantIDs
            if (!participantIDs) {
              participantIDs = {}
            }
            participantIDs[userID] = true

            var participants = doc.data().participants
            if (!participants) {
              participants = {}
            }
            participants[userID] = {
              grapes: []
            }
            grapevineRef.update({
              participantIDs: participantIDs,
              participants: participants
            }).then(function () {
              console.log('Groupvine successfully updated!')
            }).catch(function (error) {
              console.error('Error removing document: ', error)
            })
            vm.participants.push({
              id: userID,
              username : username
            })
          }
        })
      },
      removeParticipant: function (userID, username) {
        console.log(userID)
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            var participantIDs = doc.data().participantIDs
            participantIDs[userID] = false
            grapevineRef.update({
              participantIDs: participantIDs,
            }).then(function () {
              console.log('Groupvine successfully updated!')
            }).catch(function (error) {
              console.error('Error removing document: ', error)
            })
            vm.participants.splice(vm.participants.findIndex(function (i) {
              return i.id === userID;
            }), 1)
          }
        })
      },
      removeGrapeFromGrapevine: function (grapeID) {
        let vm = this
        var r = confirm('Are you sure you want to remove this grape from the grapevine?')
        if (r === true) {
          mixpanel.track(
            'Remove grape from grapevine',
            {
              'grapevineID': vm.currentGrapevineID,
              'grapeID': grapeID
            }
          )
          $('#grape-' + grapeID).slideUp(400)
          var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
          grapevineRef.get().then(function (doc) {
            if (doc.exists) {
              var grapes = doc.data().grapes
              if ($.isArray(grapes)) {
                grapes.splice($.inArray(grapeID, grapes), 1)
                grapevineRef.update({
                  grapes: grapes,
                  modifiedGrapeID: grapeID,
                  modifiedGrapeAction: 'removed'
                })
                vm.grapes = $.grep(vm.grapes, function (e) {
                  return e.id !== grapeID
                })
              }
            }
          })
        }
      },
      backToGrapevines: function () {
        console.log('backToGrapevines')
        $('#left-col').removeClass('viewing-grapevine')
        this.isAuxView = false
        this.isRatedView = false
        $('#grapes-list-wrap').removeClass('is-read-only is-owner is-private')
        this.grapes = []
        this.auxGrapes = []
        mixpanel.track(
          'Back to grapevine list'
        )
      },
      deleteGrapevine: function () {
        let vm = this
        if (!vm.currentGrapevineOwner) {
          return
        }
        var r = confirm('Are you sure you want to delete this grapevine?')
        if (r === true) {
          mixpanel.track(
            'Delete grapevine',
            {
              'grapevineID': vm.currentGrapevineID
            }
          )
          var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
          grapevineRef.delete().then(function () {
            console.log('Document successfully deleted!')
            vm.getGrapevines()
          }).catch(function (error) {
            console.error('Error removing document: ', error)
          })
          $('#left-col').removeClass('viewing-grapevine')
          this.grapes = []
          Router.push(this.basePath)
        }
      },
      editGrapevineTitle: function () {
        let vm = this
        vm.titleEditing = true
        $('.grapevine-heading-wrap').addClass('is-editing')
      },
      cancelTitleEdit: function () {
        let vm = this
        vm.titleEditing = false
        $('.grapevine-heading-wrap').removeClass('is-editing')
      },
      confirmTitleEdit: function () {
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists && vm.grapevineNewName !== '') {
            grapevineRef.update({
              name: vm.grapevineNewName
            })
            vm.currentGrapevineName = vm.grapevineNewName
            vm.grapesHeading = vm.grapevineNewName
            vm.getGrapevines()
            mixpanel.track(
              'Grapevine name changed',
              {
                'grapevineID': vm.currentGrapevineID
              }
            )
          }
        })
        vm.titleEditing = false
        $('.grapevine-heading-wrap').removeClass('is-editing')
      },
      makeGrapevinePrivate: function () {
        let vm = this
        let grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)

        grapevineRef.update({
          privacy: 'private'
        })

        vm.getGrapevines()
        vm.currentGrapevinePrivate = true
        // $('#left-col').removeClass('viewing-grapevine')
        // this.grapes = []
      },
      makeGrapevinePublic: function () {
        let vm = this
        let grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)

        grapevineRef.update({
          privacy: 'public'
        })

        vm.getGrapevines()
        vm.currentGrapevinePrivate = false
        // $('#left-col').removeClass('viewing-grapevine')
        // this.grapes = []
      },
      changeGrapevinePrivacy: function () {
        if (this.grapevinePrivacy == 'public') {
          this.makeGrapevinePublic()
        } else {
          this.makeGrapevinePrivate()
        }
      },
      shareGrapevineShow: function () {
        $('.grapevine-share-wrap').find('.share-links').slideToggle(400)
      },
      shareGrapevine: function (network) {
        let vm = this
        mixpanel.track(
          'Grapevine Shared',
          {
            'network': network,
            'grapevineID': vm.currentGrapevineID
          }
        )
        if (network === 'link') {
          var dummy = document.createElement('input'),
              text = vm.grapevinePath + vm.currentGrapevineID;

          document.body.appendChild(dummy);
          dummy.value = text;
          dummy.select();
          document.execCommand('copy');
          document.body.removeChild(dummy);
          vm.$noty.success('Link copied')
        }
      },
      shareAuxShow: function () {
        $('.author-share-wrap').find('.share-links').slideToggle(400)
      },
      shareAux: function (network, link) {
        let vm = this
        mixpanel.track(
          'Aux List Shared',
          {
            'network': network,
            'Aux': vm.author
          }
        )
        if (network === 'link') {
          var dummy = document.createElement('input'),
              text = link;

          document.body.appendChild(dummy);
          dummy.value = text;
          dummy.select();
          document.execCommand('copy');
          document.body.removeChild(dummy);
          vm.$noty.success('Link copied')
        }
      },
      addGrapevine: function () {
        console.log('addGrapevine')
        let vm = this
        $('#dialog-confirm').text('Would you like to follow this grapevine, or copy it to craft your own variation?')
        $('#dialog-confirm').dialog({
          title: 'Add this Grapevine',
          buttons: {
            'Follow': function () {
              $(this).dialog('close')
              var userRef = firebase.database().ref('users/' + vm.currentUserID)
              userRef.once('value').then(function (snapshot) {
                var grapevinesFollowed = snapshot.val().grapevinesFollowed
                if ($.isArray(grapevinesFollowed)) {
                  if ($.inArray(vm.currentGrapevineID, grapevinesFollowed) === -1) {
                    grapevinesFollowed.push(vm.currentGrapevineID)
                    userRef.update({
                      grapevinesFollowed: grapevinesFollowed
                    })
                    const req = Request
                    .post('https://us-central1-grapevine-dc853.cloudfunctions.net/followGrapevine')
                    .query({
                      grapevineID: vm.currentGrapevineID,
                      userID: vm.currentUserID
                    })
                    .then(function() {
                      console.log('updated grapevine followers array (add)')
                    })  
                  }
                } else {
                  userRef.update({
                    grapevinesFollowed: [vm.currentGrapevineID]
                  })
                }
                vm.$eventHub.$emit('user-followed-grapevine', vm.currentGrapevineID)
                mixpanel.track(
                  'User followed grapevine',
                  {
                    'grapevineID': vm.currentGrapevineID
                  }
                )
                vm.getGrapevines()
                vm.backToGrapevines()
              })
            },
            'Duplicate': function () {
              vm.duplicateGrapevine()
              $(this).dialog('close')
            },
            Cancel: function () {
              $(this).dialog('close')
            }
          }
        })
        $('#dialog-confirm').dialog('open')
      },
      duplicateGrapevine: function () {
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.currentGrapevineID)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            var grapevine = doc.data()
            grapevine.userID = vm.currentUserID
            db.collection(vm.grapevinesDatabase).add(grapevine)
            vm.$eventHub.$emit('user-duplicated-grapevine', vm.currentGrapevineID)
            mixpanel.track(
              'User duplicated grapevine',
              {
                'grapevineID': vm.currentGrapevineID
              }
            )
            vm.getGrapevines()
            vm.backToGrapevines()
          }
        })
      },
      removeGrapevine: function () {
        let vm = this
        var userRef = firebase.database().ref('users/' + vm.currentUserID)
        userRef.once('value').then(function (snapshot) {
          var grapevinesFollowed = snapshot.val().grapevinesFollowed
          if ($.isArray(grapevinesFollowed)) {
            grapevinesFollowed.splice($.inArray(vm.currentGrapevineID, grapevinesFollowed), 1)
            userRef.update({
              grapevinesFollowed: grapevinesFollowed
            })
            const req = Request
            .post('https://us-central1-grapevine-dc853.cloudfunctions.net/unfollowGrapevine')
            .query({
              grapevineID: vm.currentGrapevineID,
              userID: vm.currentUserID
            })
            .then(function() {
              console.log('updated grapevine followers array (remove)')
            })  
          }

          vm.$eventHub.$emit('user-unfollowed-grapevine', vm.currentGrapevineID)
          mixpanel.track(
            'User unfollowed grapevine',
            {
              'grapevineID': vm.currentGrapevineID
            }
          )
          vm.getGrapevines()
          vm.backToGrapevines()
        })
      },
      initDialog: function () {
        $('body').append('<div id="dialog-confirm"></div>')
        $('#dialog-confirm').dialog({
          autoOpen: false,
          resizable: false,
          height: 'auto',
          width: 400,
          modal: true
        })
      },
      checkCurrentGrapevineOwner: function (grapevineID) {
        console.log('checking current owner, is admin: ' + this.$globals.userCanEditGrapevines + ', role: ' + this.$globals.userRole)
        let vm = this
        $('#grapes-list-wrap').addClass('is-read-only')
        if (this.$globals.userCanEditGrapevines) {
          vm.currentGrapevineOwner = true
          $('#grapes-list-wrap').addClass('is-admin')
          $('#grapes-list-wrap').removeClass('is-read-only')
        }
        if (grapevineID) {
          var grapevineRef = db.collection(vm.grapevinesDatabase).doc(grapevineID)
          grapevineRef.get().then(function (doc) {
            if (doc.exists) {
              let grapevine = doc.data()
              vm.currentGrapevineUserID = grapevine.userID
              vm.getUsernameFromID(grapevine.userID)
              if (vm.currentGrapevineUserID === vm.currentUserID) {
                vm.currentGrapevineOwner = true
                $('#grapes-list-wrap').addClass('is-owner')
                $('#grapes-list-wrap').removeClass('is-read-only')
              } else {
                vm.currentGrapevineOwner = false
                $('#grapes-list-wrap').removeClass('is-owner')
                $('#grapes-list-wrap').addClass('is-read-only')
              }
            }
          })
        }
      },
      scrollToGrape: function (grapeID) {
        this.scrollGrapeID = null
        if ($('#grape-' + grapeID).length > 0) {
          let grapeTop = $('#grape-' + grapeID).offset().top - 80
          console.log(grapeTop)
          $('html, body').animate({ scrollTop: grapeTop }, 'slow')
          if (this.forceLHShow) {
            this.forceLHShow = false
            $('html').removeClass('fixed')
          }
        } else {
          this.firstLoad = true
          this.scrollGrapeID = grapeID
          Router.push({name: 'grapevine',  params: { id: this.currentGrapevineID, name: encodeURIComponent(this.currentGrapevineName) }})
        }
      },
      setupViewAuthor: function (id) {
        this.getAuthorGrapes(id)
      },
      getAuthorGrapes: function (author) {
        console.log('getAuthorGrapes sidebar: ' + author)
        let vm = this
        vm.isAuxView = true
        vm.auxGrapes = []
        db.collection(vm.grapesDatabase).where('sourceAuthor', '==', author).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            if (vm.isPress) {
              if (!grapeData.sourceImage) {
                grapeData.sourceImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
              }
            }
            vm.auxGrapes.push(grapeData)
          })
        })
      },
      setupViewBook: function (title) {
        this.getBookGrapes(title)
      },
      getBookGrapes: function (title) {
        console.log('getBookGrapes sidebar: ' + title)
        let vm = this
        vm.isAuxView = true
        vm.auxGrapes = []
        db.collection(vm.grapesDatabase).where('grapeSource', '==', title).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            if (vm.isPress) {
              if (!grapeData.sourceImage) {
                grapeData.sourceImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
              }
            }
            vm.auxGrapes.push(grapeData)
          })
        })
      },
      setupViewPublication: function (title) {
        this.getAuthorGrapes(title)
      },
      getPublicationGrapes: function (title) {
        console.log('getPublicationGrapes sidebar: ' + title)
        let vm = this
        vm.isAuxView = true
        vm.auxGrapes = []
        db.collection(vm.grapesDatabase).where('grapePublication', '==', title).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            if (vm.isPress) {
              if (!grapeData.sourceImage) {
                grapeData.sourceImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
              }
            }
            vm.auxGrapes.push(grapeData)
          })
        })
      },
      getTopRated: function() {
        console.log('getTopRated')
        let vm = this
        db.collection(vm.grapeRatingsDatabase).where('userID', '==', vm.currentUserID).where('rating', '==', '5').get().then((querySnapshot) => {
          vm.ratedVine.count = querySnapshot.docs.length
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            db.collection(vm.grapesDatabase).where('id', '==', grapeData.grapeID).get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                var grapeData = doc.data()
                if (!vm.ratedVine.grapeImage) {
                  vm.ratedVine.grapeImage = grapeData.sourceImage
                  if (vm.isPress) {
                    if (!grapeData.sourceImage) {
                      vm.ratedVine.grapeImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
                    }
                  }
                  vm.ratedVine.grapeImage = vm.ratedVine.grapeImage.replace('http://', 'https://')
                }
              })
            })
          })
        })
      },
      showTopRated: function () {
        this.isAuxView = false
        this.isRatedView = true
      },
      getRatedGrapes: function () {
        console.log('getRatedGrapes sidebar')
        let vm = this
        vm.ratedGrapes = []
        db.collection('grapeRatings').where('userID', '==', vm.currentUserID).where('rating', '==', '5').orderBy('createdTimestamp', 'desc').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var data = doc.data()
            vm.ratedGrapeIDs.push(data.grapeID)
          })
          vm.ratedGrapeIDs.forEach(grapeID => {
            db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                if (!vm.checkGrapePresent(vm.ratedGrapes, grapeData.id, true)) {
                  vm.ratedGrapes.push(grapeData)
                } else {
                  console.log('rated grapes has duplicate')
                }
                $('#left-col').stop().animate({ scrollTop: 0 }, '400', function () {
                  $(window).trigger('resize')
                })
              })
            })
          })
        })
      },
      setGrapevinesGlobal: function () {
        let vm = this
        vm.$globals.userGrapevines = vm.grapevines
      }
    },
    mounted: function () {
      (function ($) {
        $('body').append('<div id="dialog-confirm"></div>')
        $('#dialog-confirm').dialog({
          autoOpen: false,
          resizable: false,
          height: 'auto',
          width: 400,
          modal: true
        })
      }(jQuery))

      $(document).on('click', '.add-grapevine-trigger', function () {
        if ($('#grapevine_name').val().length < 3) {
          $('#grapevine_name').focus()
        }
      })
    }
  };
</script>
<style scoped>
	.aux-col {
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;
  }
  .aux-col > div {
  	padding: 30px 20px;
  	transform: translateX(0);
  	-moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
		-webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
		transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  .aux-col h5.aux-heading {
    /*border-bottom: 1px solid #36a731;*/
    margin: 0 0 10px;
    padding-bottom: 8px;
    display: inline-block;
    font-size: 1em;
    font-weight: 100;
    max-width: 65%;
    color: #176b0e;
  }
  .aux-col fieldset {
    max-width: 100%;
    box-sizing: border-box;
    min-width: 0;
    height: auto;
    overflow: hidden;
    clear: both;
  }
  .aux-col fieldset .input-field {
    float: left;
    width: 75%;
  }
  .aux-col fieldset input {
    margin: 0;
    width: 100%;
  }
  .aux-col fieldset button {
    padding: 7px;
    margin-left: 5px;
    float: right;
    width: 20%;
  }
  #left-col[hidesidebars="true"] {
    display: none!important;
  }
  .add-grapevine-form {
    position: relative;
    margin-bottom: 30px;
    clear: both;
  }
  #grapevine_name {
    width: 100%;
    line-height: 34px;
    padding: 10px 10px 10px 40px;
    box-sizing: border-box;
    background: transparent;
    border: 1px solid #ccc;
    border-left: 0;
    border-right: 0;
    -webkit-appearance: none;
  }
  .add-grapevine-trigger {
    position: absolute;
    left: 10px;
    top: 19px;
    cursor: pointer;
  }
  .add-grapevine-trigger i.fa-circle-notch {
    display: none;
  }
  .add-grapevine-trigger.is-adding i {
    display: none;
  }
  .add-grapevine-trigger.is-adding i.fa-circle-notch {
    display: inline-block;
  }
  .add-grapevine-form .notice {
    font-weight: 100;
    color: red;
  }
  .add-grapevine-form .notice:empty {
    display: none;
  }
  .view-grapevines-button {
    width: 100%;
    border: 1px solid #ccc;
    background: transparent;
    color: #666;
    margin-bottom: 30px;
    padding: 15px;
    font-weight: 400;
  }
  .view-grapevines-button:hover {
    color: #36a731;
    border-color: #36a731;
  }
  .grapevines-heading-wrap select {
    float: right;
    background: transparent;
    border: 0;
    margin-top: -1px;
    opacity: 0.7;
  }
	#grapes-list-wrap {
		box-sizing: border-box;
    position: absolute;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    width: 100%;
	}
	#left-col.viewing-grapevine #grapevines-list-wrap {
	  -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
	}
	#left-col.viewing-grapevine #grapes-list-wrap {
	  transform: translateX(0);
	}
  #grapes-list-wrap .delete-grapevine {
    display: none;
  }
  #grapes-list-wrap .add-grapevine {
    display: inline-block;
    background-color: #007F00;
  }
  #grapes-list-wrap.is-owner .delete-grapevine {
    display: inline-block;
  }
  #grapes-list-wrap.is-admin .add-grapevine, #grapes-list-wrap.is-admin .delete-grapevine  {
    display: inline-block;
  }
  #grapes-list-wrap.is-admin.is-following .add-grapevine, #grapes-list-wrap.is-owner .add-grapevine, #grapes-list-wrap.is-read-only.is-following .add-grapevine {
    display: none;
  }
  #grapes-list-wrap.is-read-only.is-following .remove-grapevine {
    display: inline-block;
  }
  .grapevine-heading-wrap {
    height: auto;
    overflow: hidden;
  }
  .aux-col .grapevine-heading-wrap h5.aux-heading {
    max-width: 60%;
    line-height: 1.5;
    text-decoration: none;
    color: #222;
  }
  .grapevine-heading-wrap .is-editing-show {
    display: none;
  }
  .grapevine-heading-wrap.is-editing .is-editing-show {
    display: inline-block;
  }
  .grapevine-heading-wrap.is-editing .is-editing-hide {
    display: none;
  }
  .grapevine-heading-wrap input {
    width: 48%;
    padding: 4px 5px;
    margin-bottom: 17px;
  }
  .grapevine-heading-wrap > div {
    float: right;
    margin-left: 10px;
    padding: 1px 0;
    cursor: pointer;
  }
  .grapevine-back-button {
  	cursor: pointer;
  }
  .remove-grape {
  	cursor: pointer;
  }
  .sidebar-share-wrap {
    height: auto;
    overflow: hidden;
    padding-top: 5px;
    margin-bottom: 30px;
  }
  .sidebar-share-wrap > button {
    margin-bottom: 10px;
    font-weight: 100;
    font-size: 16px;
    height: 42px;
    line-height: 42px;
    padding: 0 10px;
  }
  .sidebar-share-wrap > button > i {
    display: none;
  }
  .sidebar-share-wrap > .share-links {
    display: none;
  }
  .private-public-switch {
    width: 48%;
    float: right;
  }
  .add-grapevine {
    width: 48%;
    color: #fff;
    font-weight: 700;
    background color: #007F00;
  }
  .grapevine-share-button {
    width: 48%;
    margin-right: 4%;
    float: left;
    background-color: #36a731;
  }
  .delete-grapevine {
    width: 48%;
    color: #fff;
    background-color: #82929e;
  }
  .remove-grapevine {
    display: none;
    color: #fff;
    width: 48%;
    background-color: #82929e;
  }
  .grapevine-public-button, .grapevine-private-button {
    width: 48%;
    margin-right: 0;
    float: left;
    background-color: #82929e;
    color: #fff;
  }
  .grapevine-groupvine-button {
    width: 100%;
    float: left;
    border: 1px solid #36a731;
    color: #36a731;
    background: transparent;
  }
  .share-links {
    list-style: none;
    margin: 0;
    padding: 0;
    clear: both;
  }
  .share-links:hover li {
    opacity: 0.5;
  }
  .share-links > li {
    margin-left: 10px;
    float: left;
    padding: 5px;
    cursor: pointer;
  }
  .share-links > li:hover {
    opacity: 1;
  }  
  .share-links > li:first-child {
    margin-left: 0;
  }
  .share-links li i, .share-links li a {
    color: #36a731;
  }
  .share-links li svg {
    display: block;
    margin-top: -3px;
  }
  a.context-edit-grapevine {
    padding: 0 5px;
    color: #222;
  }
  #aux-grapes-wrap {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    width: 100%;
  }
  #rated-grapes-wrap {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    width: 100%;
  }
  #left-col.viewingAux #grapevines-list-wrap, #left-col.viewingRated #grapevines-list-wrap {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  #left-col.viewingAux #aux-grapes-wrap {
    transform: translateX(0);
  }
  #left-col.viewingRated #rated-grapes-wrap {
    transform: translateX(0);
  }
  .groupvine-participants {
    margin-bottom: 20px;
  }
  .groupvine-participants h5 {
    margin: 0 0 10px;
    padding-bottom: 5px;
    font-size: 1em;
    font-weight: 100;
    color: #222;
    border-bottom: 1px solid #eaeaea;
  }
  .groupvine-participants h5 a {
    float: right;
    text-decoration: none;
    color: #aaa;
  }
  .participants-list {
    margin: 0 0 20px;
    padding: 0;
    list-style: none;
  }
  .participants-list li {
    display: inline-block;
  }
  .participants-list li:before {
    content: ', ';
    display: inline;
  }
  .participants-list li:first-child:before {
    display: none;
  }
  .participants-list li a {
    text-decoration: none;
    color: #36a731;
  }
  .groupvine-chat-button {
    width: 100%;
  }
  .current-participants-list li {
    display: block;
    margin-bottom: 10px;
  }
  .current-participants-list li:before {
    content: '';
    display: none;
  }
  .current-participants-list li a:after {
    content: 'remove';
    display: inline-block;
    color: #999;
    margin-left: 0;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
  .current-participants-list li:hover a:after {
    opacity: 1;
    margin-left: 10px;
  }
  #user-search-dialog.dialog-open {
    height: auto;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -100px 0 0 -160px;
    width: 320px;
    padding: 0 40px 40px;
    background: #fafafa;
    border: 1px solid #eee;
    z-index: 9999;
    overflow: hidden;
    -webkit-transition: none;
    transition: none;
    box-sizing: border-box;
  }
  #user-search-dialog .dialog-close {
    font-size: 30px;
    position: absolute;
    top: 10px;
    right: 40px;
    cursor: pointer;
  }
  .search-dialog-inner {
    position: relative;
    margin-bottom: 20px;
  }
  .user-search {
    position: relative;
    margin-bottom: 30px;
  }
  #participant-search-users {
    width: 100%;
    line-height: 34px;
    padding: 10px 10px 10px 40px;
    box-sizing: border-box;
    background: transparent;
    border: 1px solid #ccc;
    border-left: 0;
    border-right: 0;
  }
  .search-trigger {
    position: absolute;
    left: 10px;
    top: 50%;
    margin-top: -9px;
    cursor: pointer;
  }
  #participant-users-list {
    list-style: none;
    margin: 0 0 30px;
    padding: 0;
  }
  #participant-users-list li {
    padding: 10px 0;
  }
  #participant-users-list li a {
    color: #36a731;
    text-decoration: none;
    display: block;
    -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
    transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  }
  #participant-users-list li a:hover {
    color: #222;
  }
  #user-search-dialog h5 {
    margin: 20px 0 10px;
  }
  .start-grapevine {
    background: rgb(64,181,58);
    background: -moz-linear-gradient(90deg, rgba(64,181,58,1) 0%, rgba(78,201,71,1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(64,181,58,1) 0%, rgba(78,201,71,1) 100%);
    background: linear-gradient(90deg, rgba(64,181,58,1) 0%, rgba(78,201,71,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#40b53a",endColorstr="#4ec947",GradientType=1);
    color: #fff;
    text-align: center;
    padding: 20px;
    margin: 40px 25px;
    cursor: pointer;
  }
  .start-grapevine:hover {
    opacity: 0.8;
  }
  @media only screen and (min-width: 1200px) {
    #left-col {
      height: 100%;
      height: calc(100% - 47px);
      width: 17%;
      position: fixed;
      z-index: 2;
      left: 0!important;
      top: 53px;
      padding-bottom: 50px;
    }
    #left-col > div {
      height: calc(100vh - 53px);
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      box-sizing: border-box;
    }
  }
  @media only screen and (min-width: 1024px) and (max-width: 1350px) {
    .aux-col h5.aux-heading {
      max-width: 50%;
    }
  }
  @media only screen and (min-width: 1024px) and (max-width: 1199px) {
    #left-col {
      height: 100%;
      height: calc(100% - 130px);
      width: 25%;
      position: fixed;
      z-index: 3;
      left: 0;
      top: 130px;
      padding-bottom: 50px;
    }
    .tablet-view-rh #left-col {
      display: none;
    }
    #left-col > div {
      height: calc(100vh - 91px);
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      padding-top: 4px;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    #left-col {
      position: fixed;
      left: -266px;
      top: 133px;
      width: 256px;
      z-index: 99;
      box-sizing: border-box;
      background: #f9f9f9;
      border-right: 10px solid #fff;
      overflow: hidden;
    }
    .tablet-view-rh #left-col {
      z-index: 98;
    }
    /*.left-col-overlay-open #left-col {
      box-shadow: 5px 5px 36px -12px rgba(0,0,0,0.5);
    }*/
    #left-col {
      overflow: hidden;
    }
    #left-col > div {
      height: calc(100vh - 133px);
      box-sizing: border-box;
      top: 0;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      padding-top: 4px;
    }
  }
  @media only screen and (max-width: 767px) {
    #left-col {
      display: none;
      position: fixed;
      top: 0;
      z-index: 3;
      width: 100%;
      height: 100vh;
      background: #fff;
      padding-top: 54px;
    }
    #left-col > div {
      height: calc(100vh - 91px);
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
    #left-col.forceShow {
      display: block;
      left: 0!important;
    }
    .aux-col > div {
      padding: 20px 20px;
    }
    .aux-col h5.aux-heading {
      margin-bottom: 15px;
      padding-bottom: 0;
    }
    .add-grapevine-form {
      margin-bottom: 20px;
    }
    .grapevines-heading-wrap select {
      margin-top: -1px;
    }
    #grapes-list-wrap, #aux-grapes-wrap {
      top: 54px;
    }
    .grapevine-share-wrap {
      margin-bottom: 20px;
    }
    #left-col.viewingRated #rated-grapes-wrap {
      padding-top: 70px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/LeftSidebar.vue